import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { WorkplaceEffects } from './workplaces-effects';
import { reducer } from './workplaces-reducer';
import { initialWorkplacesState } from './workplaces-state';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.WORKPLACE, (reducer as ActionReducer<any, any>), {
            initialState: initialWorkplacesState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ WorkplaceEffects ])
    ],
    declarations: []
})
export class WorkplacesStateModule {}
